module.exports = __webpack_public_path__ + "img/book_icon.f217fcb6.svg";